import React from 'react';
import { Tooltip, styled } from '@mui/material';
import { colors, spacing, radius } from 'common/theme';
import { TOOLTIP_MODE, TOOLTIP_PLACEMENT } from 'pages/personal-zone/utils/enums';

const getVariantStyles = (mode) => {
  if (mode === TOOLTIP_MODE.LIGHT) {
    return {
      backgroundColor: colors.palette.white,
      textColor: colors.system.text.primary,
      arrowColor: colors.palette.white,
      borderColor: colors.palette.blueAlpha200,
      boxShadow: 'none',
    };
  }
  
  return {
    backgroundColor: colors.system.inverse.surface,
    textColor: colors.system.inverse.onSurface,
    arrowColor: colors.system.inverse.surface,
    borderColor: colors.system.inverse.surface,
    boxShadow: 'none',
  };
};

const StyledTooltip = styled(({ className, mode, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, mode = TOOLTIP_MODE.DEFAULT }) => {
  const styles = getVariantStyles(mode);

  return {
    '& .MuiTooltip-tooltip': {
      backgroundColor: styles.backgroundColor,
      color: styles.textColor,
      boxShadow: styles.boxShadow,
      fontSize: theme.typography.body2.fontSize,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightRegular,
      padding: `${spacing.sm}px ${spacing.lg}px`,
      borderRadius: radius.sm,
      border: `1px solid ${styles.borderColor}`,
    },
    '& .MuiTooltip-arrow': {
      color: styles.arrowColor,
      '&::before': {
        border: `1px solid ${styles.borderColor}`,
        backgroundColor: styles.backgroundColor,
      },
    },
  };
});

export const TooltipHot = ({
  children,
  title,
  testID,
  mode = TOOLTIP_MODE.DEFAULT,
  placement = TOOLTIP_PLACEMENT.TOP,
  arrow = true,
  open,
  onOpen,
  onClose,
  disableHoverListener = false,
  disableFocusListener = false,
  enterDelay = 0,
  leaveDelay = 0,
  ...props
}) => {
  const slotProps = testID ? {
    tooltip: { testId: testID },
    popper: { testId: `${testID}-popper` },
  } : {};

  return (
    <StyledTooltip
      title={title}
      placement={placement}
      arrow={arrow}
      mode={mode}
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      disableHoverListener={disableHoverListener}
      disableFocusListener={disableFocusListener}
      enterDelay={enterDelay}
      leaveDelay={leaveDelay}
      slotProps={slotProps}
      {...props}
    >
      {children}
    </StyledTooltip>
  );
};

export default TooltipHot;
